import moment, { Moment } from 'moment';
import { MAX_DAYS_INTERVAL } from '@modules/monitoring/constants';

// Считает разницу в днях между стартовой и конечной датой
export const checkDaysDiff = (startDate: Moment | string | number, endDate: Moment | string | number) => {
  return moment(endDate).diff(moment(startDate), 'days') < MAX_DAYS_INTERVAL;
};
